/**
 * @file AppContext.jsx
 * @location src/store/AppContext.jsx
 * @role 전역 상태 Context 제공자 + useApp 소비 훅
 *
 * useAppStore (useReducer 기반) 를 Context 에 올려서
 * 모든 하위 컴포넌트에서 useApp() 으로 { S, dispatch, act } 를 꺼내씁니다.
 *
 * 사용 패턴:
 *   const { S, act } = useApp();
 *   act('SET_NAV', { nav: 'tasks' });  // 액션 디스패치
 *   S.activeNav                      // 현재 상태 읽기
 */
import { createContext, useContext } from 'react';
import { useAppStore } from '../store/useAppStore';

// 테스트에서 직접 wrap 할 수 있도록 export — 프로덕션 코드는 useApp() 만 사용.
export const Ctx = createContext(null);

/** AppProvider — main.jsx 에서 앱 최상단에 한 번만 배치 */
export function AppProvider({ children }) {
  const store = useAppStore();
  return <Ctx.Provider value={store}>{children}</Ctx.Provider>;
}

/** useApp — AppProvider 하위 어디서든 전역 상태·액션에 접근 */
export const useApp = () => {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useApp must be inside AppProvider');
  return ctx;
};
